<template>
  <div v-if="parseSkuInfo">
    <div style="display: flex">
      <div class="sku-left" v-if="showImage">
        <goods-sku-image :skuInfo="parseSkuInfo" :imageSize="imageSize" />
      </div>
      <div class="sku-header">
        <template v-if="showInfo">
          <el-popover
            width="320"
            trigger="hover"
            placement="top-start"
            :open-delay="1000"
            :content="parseSkuInfo.goodsTitle"
          >
            <div slot="reference">
              <span v-if="parseSkuInfo.optSpec == 1" style="color: #3399ff">
                [多规格]
              </span>
              <span style="font-size: 16px; color: #333333; font-weight: 500">
                {{ parseSkuInfo.goodsTitle }}
              </span>
              <span
                v-if="
                  parseSkuInfo.goodsSkuName && parseSkuInfo.goodsSkuName != '默认规格'
                "
                style="font-size: 16px; color: #666666; font-weight: 500"
              >
                【规格：{{ parseSkuInfo.goodsSkuName }}】
              </span>
            </div>
          </el-popover>
          <div style="margin-top: 5px">
            <div style="color: #919191; font-size: 14px">
              <span>商品编号: </span>
              <span style="color: #676767">
                {{ parseSkuInfo.guid }}
              </span>
            </div>
            <div v-if="!!parseSkuInfo.dxSkuId" style="color: #3399ff; font-size: 14px">
              <span>大雄编码: </span>
              <span style="color: #676767">
                {{ parseSkuInfo.dxSkuId }}
              </span>
            </div>
            <div
              v-if="!!parseSkuInfo.goodsSkuCode"
              style="color: #919191; font-size: 14px"
            >
              <span>SKU编号: </span>
              <span style="color: #676767">
                {{ parseSkuInfo.goodsSkuCode }}
              </span>
            </div>
            <div
              v-if="!!parseSkuInfo.goodsSpuCode"
              style="color: #919191; font-size: 14px"
            >
              <span>SPU编号: </span>
              <span style="color: #676767">
                {{ parseSkuInfo.goodsSpuCode }}
              </span>
            </div>
            <div
              v-if="parseSkuInfo.goodsType == 'veterinary'"
              style="color: #919191; font-size: 14px"
            >
              <span> 通用名称: </span>
              <span style="color: #676767" v-if="parseSkuInfo.genericName">
                {{ parseSkuInfo.genericName }}
              </span>
              <span v-else> 未设置通用名称 </span>
            </div>
            <div
              v-if="parseSkuInfo.goodsType == 'veterinary'"
              style="color: #919191; font-size: 14px"
            >
              <span> 批准文号: </span>
              <span style="color: #676767" v-if="parseSkuInfo.approvalNum">
                {{ parseSkuInfo.approvalNum }}
              </span>
              <span v-else> 未设置批准文号 </span>
            </div>
            <div style="color: #919191; font-size: 14px">
              <span> 商品条码: </span>
              <span style="color: #676767" v-if="parseSkuInfo.goodsUpc">
                {{ parseSkuInfo.goodsUpc }}
              </span>
              <span v-else> 未设置商品条码 </span>
            </div>
            <!-- <div style="color: #919191; font-size: 14px">
              <span>商品规格: </span>
              <span style="color: #676767" v-if="parseSkuInfo.goodsSpec">
                {{ parseSkuInfo.goodsSpec }}
              </span>
              <span v-else> 未设置商品规格 </span>
            </div> -->
            <div v-if="showCostPrice" style="color: #919191; font-size: 14px">
              <span>成本单价: </span>
              <span style="color: #676767" v-if="parseSkuInfo.averageCostPrice > 0">
                {{ parseSkuInfo.averageCostPrice }}元/件
              </span>
              <span v-else> 暂无库存成本单价 </span>
            </div>
            <div
              v-if="parseSkuInfo.purchasePrice > 0"
              style="color: #919191; font-size: 14px"
            >
              <span>上次采购单价: </span>
              <span style="color: #ff6b6b"> {{ parseSkuInfo.purchasePrice }}元/件 </span>
            </div>
          </div>
        </template>
        <slot name="info-append" :info="parseSkuInfo" />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.sku-left {
  font-size: 12px;
  margin-right: 12px;
}

.sku-header {
  font-size: 14px;
  line-height: 18px;
}
</style>

<script>
import { Image as vanImage } from "vant";
import "vant/lib/image/style";
import GoodsSkuImage from "./goodsSkuImage.vue";

export default {
  components: {
    vanImage,
    GoodsSkuImage,
  },
  props: {
    showInfo: {
      type: Boolean,
      default: true,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    showCostPrice: {
      type: Boolean,
      default: false,
    },
    imageSize: {
      type: Number,
      default: 60,
    },
    skuInfo: {
      type: Object,
    },
  },
  computed: {
    parseSkuInfo() {
      if (this.skuInfo && this.skuInfo.skuInfo) {
        return Object.assign({}, this.skuInfo, this.skuInfo.skuInfo);
      }
      return this.skuInfo;
    },
  },
  methods: {
    getGoodsImageUrl() {
      return (
        `${this.skuInfo && this.skuInfo.image}`.split("|")[0] ||
        this.getConfig("defaultImageUrl")
      );
    },
  },
};
</script>
